import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils/Styles';
import {
	CategorySpan,
	NavCategoryLink,
} from './navCategoryBarStyles';
import GiftIcon from './GiftIcon';

class NavCategoryMarkup extends PureComponent {
	render () {
		const {
			slug,
			long,
			short,
			onMouseEnter,
			onMouseLeave,
			type,
			icon,
			linkColor,
			accentColor,
			highlight,
			href,
		} = this.props;
		return (
			<NavCategoryLink
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
				linkColor={linkColor}
				accentColor={accentColor}
				highlight={highlight}
				data-slug={slug}
				href={href}>
				<CategorySpan
					linkColor={linkColor}
					accentColor={accentColor}
					catType={type}
					fullText
				>
					{icon && (
						<GiftIcon
							width={24}
							height={24}
							// Holiday logo change revert in 2023
							fill={getColor("holidayRed")}
							style={{ paddingRight: 4 }}
						/>
					)}
					{long}
				</CategorySpan>
				<CategorySpan
					accentColor={accentColor}
					catType={type}
					shortText
				>
					{short}
				</CategorySpan>
			</NavCategoryLink>
		);
	}

	static propTypes = {
		slug: PropTypes.string.isRequired,
		long: PropTypes.string.isRequired,
		short: PropTypes.string.isRequired,
		onMouseEnter: PropTypes.func,
		onMouseLeave: PropTypes.func,
		type: PropTypes.oneOf(["campaign", "category", "collection"]),
		icon: PropTypes.bool,
		linkColor: PropTypes.string,
		accentColor: PropTypes.string,
		highlight: PropTypes.bool,
		href: PropTypes.string,
	}

	static defaultProps = {
		type: "category",
		icon: false,
	}
}

export default NavCategoryMarkup;
